import script from "./AppCipheredText.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCipheredText.vue?vue&type=script&setup=true&lang=js"

import "./AppCipheredText.vue?vue&type=style&index=0&id=72209d0e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72209d0e"]])

export default __exports__